module.exports = __webpack_public_path__ + "img/caja3.c5554217.gif";